import { ROUTES } from '@common/enums'
import { QuizTabType } from '@lib/types/quizzes'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

type UseTabsOptionsType = {
  defaultTab: QuizTabType
}

const useTabs = ({ defaultTab }: UseTabsOptionsType) => {
  const [activeTab, setActiveTab] = useState<QuizTabType>(defaultTab)

  const router = useRouter()

  useEffect(() => {
    if (activeTab.value === 'All practice quizzes')
      router.push(ROUTES.QUIZZES_LIST)
    else if (activeTab.value === 'Leaderboard')
      router.push(ROUTES.QUIZZES_LEADERBOARD)
  }, [activeTab])

  return { activeTab, setActiveTab }
}

export default useTabs
